import axios from "axios";
import { ZLoginFormData } from "src/types/ZLoginFormData";
import { ZUser, zUser } from "src/types/ZUser";

import { rest } from "../rest";
import { getApiUrl } from "./getUrl";

export const getCurrentUser = async (): Promise<ZUser> => {
  const resp = await rest.get<ZUser>(getApiUrl("/auth/current"));
  return zUser.parse(resp.data);
};

export const login = async (params: ZLoginFormData) =>
  axios.post(getApiUrl("/auth/login"), params);

export const logout = async () => axios.post(getApiUrl("/auth/logout"));

export const refresh = async () => axios.post(getApiUrl("/auth/refresh"));
